import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronDownIcon, CoinIcon } from '../../../model/icons';
import BetRow from './BetRow';
import { plBets } from './betUtils';

// Строка игрока (.bt-player): аккордеон со всеми ставками игрока (спорт + мероприятия).
export default function PlayerRow({ player, index }) {
    const { username, totalBets, totalStaked, bets, activityBets } = player;
    const [open, setOpen] = useState(false);

    const byDateDesc = (a, b) => new Date(b.startTime) - new Date(a.startTime);
    const sportBets = Array.isArray(bets) ? [...bets].sort(byDateDesc) : [];
    const meroBets = Array.isArray(activityBets) ? [...activityBets].sort(byDateDesc) : [];
    const hasBets = (totalBets || 0) > 0;

    const toggle = () => { if (hasBets) setOpen(!open); };

    return (
        <div className={`bt-player${open ? ' open' : ''}${hasBets ? '' : ' empty'}`}>
            <div className="bt-phead" role="button" tabIndex={0} onClick={toggle} onKeyDown={(e) => { if (e.key === 'Enter') toggle(); }}>
                <span className="bt-prank">{index + 1}</span>
                <span className="bt-puser">{username || 'Без имени'}</span>
                <span className="bt-pstats">
                    <span className="bt-pbets">{plBets(totalBets)}</span>
                    <span className="bt-pstaked">{totalStaked || 0} <CoinIcon /></span>
                </span>
                {hasBets && <span className="bt-chev"><ChevronDownIcon /></span>}
            </div>
            {open && (
                <div className="bt-pbody">
                    {sportBets.length > 0 && (
                        <>
                            <div className="bt-pgroup">Спортивные ставки</div>
                            <div className="bt-bets">
                                {sportBets.map(bet => (
                                    <BetRow key={`s-${bet.id}`} bet={bet} finished={bet.eventStatus === 'FINISHED'} showEvent />
                                ))}
                            </div>
                        </>
                    )}
                    {meroBets.length > 0 && (
                        <>
                            <div className={`bt-pgroup${sportBets.length > 0 ? ' mt' : ''}`}>Ставки на мероприятия</div>
                            <div className="bt-bets">
                                {meroBets.map(bet => (
                                    <BetRow key={`a-${bet.id}`} bet={bet} finished={bet.eventStatus === 'FINISHED'} showEvent />
                                ))}
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

PlayerRow.propTypes = {
    player: PropTypes.shape({
        userId: PropTypes.number,
        username: PropTypes.string,
        totalBets: PropTypes.number,
        totalStaked: PropTypes.number,
        bets: PropTypes.array,
        activityBets: PropTypes.array
    }).isRequired,
    index: PropTypes.number.isRequired
};
